import type { ButtonProps, PolymorphicComponentProps } from '@mantine/core';
import { Button as MantineButton } from '@mantine/core';
import React from 'react';

import styles from './Button.module.css';

export const LBButton = React.forwardRef<
  React.ElementRef<typeof MantineButton>,
  PolymorphicComponentProps<'button', ButtonProps>
>(({ children, ...props }, ref) => (
  <MantineButton classNames={styles} {...props} ref={ref}>
    {children}
  </MantineButton>
));
